import { gql } from "@apollo/client";

export const GET_IMPRIMIR_DOCUMENTOS = gql`
    query GetImprimirDocumentos($documentos: [DocumentoImpresionModelInput!]!) {
        imprimirDocumentos(documentos: $documentos) {
            success
            error
            valorEsperado
        }
    }
`;